import styled from "styled-components";

export const FormElementContainer = styled.section`
  max-width: 600px;
  margin: auto;
  padding: 32px;
  background: linear-gradient(
    135deg,
    rgba(26, 27, 53, 0.8),
    rgba(19, 27, 60, 0.8)
  );
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  box-shadow: 0 4px 24px -1px rgba(0, 0, 0, 0.2),
    0 1px 2px rgba(255, 255, 255, 0.05),
    inset 0 1px 1px rgba(255, 255, 255, 0.03);

  /* Subtle inner glow on hover */
  &:hover {
    background: linear-gradient(
      135deg,
      rgba(26, 27, 53, 0.85),
      rgba(19, 27, 60, 0.85)
    );
    box-shadow: 0 4px 24px -1px rgba(0, 0, 0, 0.2),
      0 1px 2px rgba(255, 255, 255, 0.05),
      inset 0 1px 1px rgba(255, 255, 255, 0.05);
  }

  /* Subtle grid pattern overlay */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    background: repeating-linear-gradient(
        45deg,
        rgba(255, 255, 255, 0.02) 0px,
        rgba(255, 255, 255, 0.02) 1px,
        transparent 1px,
        transparent 8px
      ),
      repeating-linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.02) 0px,
        rgba(255, 255, 255, 0.02) 1px,
        transparent 1px,
        transparent 8px
      );
    border-radius: inherit;
  }

  position: relative;
  overflow: hidden;

  @media (max-width: 600px) {
    padding: 24px;
    margin: 16px;
    border-radius: 12px;
  }
`;
